import en from './en.json';
import railsData from 'utilities/rails-data';
import {notifyException} from 'utilities/analytics/bugsnag';

const i18nArgs = {
  id: 'ServiceIndex',
  fallback: en,
  async translations() {
    const locale = railsData('locale') || 'en';
    try {
      const dictionary = await import(
        /* webpackChunkName: "ServiceIndex-i18n-[request]" */ `./${locale}.json`
      );
      return dictionary;
    } catch (error) {
      notifyException({
        errorName: 'I18n:ServiceIndex',
        error,
      });
    }
    return en;
  },
};

export default i18nArgs;
